import { useState, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Menu } from "@headlessui/react";
//for conversion of country code to country name and back
const convertToCode = (country: string) => {
  if (country == "Singapore") {
    return "SG";
  } else if (country == "Malaysia") {
    return "MY";
  }
};
export const convertToName = (countryCode: string) => {
  if (countryCode == "SG") {
    return "Singapore";
  } else if (countryCode == "MY") {
    return "Malaysia";
  }
};
//dropdown menu component
interface MenuItemProps {
  country: string;
  onClick: () => void;
  selectedCountry: string;
  componentId?: string;
}
const MenuItem = ({ country, onClick, selectedCountry, componentId }: MenuItemProps) => {
  const countryCode = convertToCode(country);
  const isActive = countryCode === selectedCountry;

  return (
    <Menu.Item>
      <div className="flex h-[36px] w-[151px] flex-row items-center gap-8">
        <div
          id={componentId + "-button-" + country}
          className={`group flex w-full items-center rounded-md px-2 py-2 text-sm ${
            isActive ? "bg-gray-200" : ""
          }`}
          onClick={onClick}
          aria-label="Select Country"
        >
          <CountryLogos
            componentId={componentId + "-button"}
            country={countryCode ? countryCode : ""}
            className="font-inter ml-[10px] text-sm font-semibold leading-[20px] text-black"
          />
        </div>
      </div>
    </Menu.Item>
  );
};
//country logo & name component
interface CountryLogo {
  country: string;
  className?: string;
  componentId?: string;
}
const CountryLogos = ({ country, className, componentId }: CountryLogo) => {
  const [logoUrl, setLogoUrl] = useState<string>(""); // Start with empty to prevent initial wrong request

  useEffect(() => {
    const determineLogo = () => {
      if (country === "SG") {
        setLogoUrl("/img/flags/singapore.png");
      } else if (country === "MY") {
        setLogoUrl("/img/flags/malaysia.png");
      } else {
        setLogoUrl(""); // Clear for unknown countries
      }
    };
    determineLogo();
  }, [country]);
  
  const countryName = convertToName(country);
  
  return (
    <div className="flex items-center">
      {logoUrl && (
        <img
          id={componentId + "-country-logo-" + countryName}
          src={logoUrl}
          alt={`${country}-flag`}
          className="h-[20px] w-[20px] rounded-full border border-gray-300 object-cover object-left"
        />
      )}
      <span id={componentId + "-country-text-" + countryName} className={className}>{countryName}</span>
    </div>
  );
};
//navbar component
interface CountryProps {
  componentId?: string;
  countryCode: string;
  setCountry: (selectedCountry: string) => void;
}
export const CountryNavbarComponent = ({
  componentId,
  countryCode,
  setCountry,
}: CountryProps) => {
  //selectedCountry will be used as a State element to account for changes for the navbar
  const [selectedCountry, setSelectedCountry] = useState<string>(countryCode);
  const handleCountrySelect = (userSelectedCountry: string) => {
    setSelectedCountry(userSelectedCountry);
    setCountry(userSelectedCountry);
  };
  return (
    <nav className="fixed z-50 w-full bg-[#2C5862] shadow">
      <div className="mx-auto flex items-center justify-between px-4 pr-0 md:px-8 md:pr-0">
        <div>
          <div className="flex items-center justify-between py-5"></div>
        </div>
        <div>
          <div className={"mt-0 block flex-1 justify-self-center pb-0"}>
            <ul className="items-center justify-center space-y-8">
              <li className="flex items-center">
                <Menu as="div" id={componentId + "-menu"} className="relative inline-block text-left">
                  <Menu.Button className="fp-menu-button-filled right-3 z-10 flex items-center border-transparent bg-transparent">
                    <CountryLogos
                      componentId={componentId + "-selected"}
                      country={selectedCountry}
                      className="font-inter mx-2.5 text-sm font-bold text-white"
                    />
                    <ChevronDownIcon className="h-5 w-5" />
                  </Menu.Button>
                  <Menu.Items className={"fp-menu-items-filled right-6"}>
                    <div className="flex flex-col items-start justify-center px-1 py-1">
                      <MenuItem
                        componentId={componentId + "-menu-item"}
                        country="Singapore"
                        onClick={() => handleCountrySelect("SG")}
                        selectedCountry={selectedCountry}
                      />
                      <MenuItem
                        componentId={componentId + "-menu-item"}
                        country="Malaysia"
                        onClick={() => handleCountrySelect("MY")}
                        selectedCountry={selectedCountry}
                      />
                    </div>
                  </Menu.Items>
                </Menu>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
